import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/areas`, {params})
    },
    create(params) {
        return Vue.axios.post(`/areas/create`, params)
    },
    update(params) {
        return Vue.axios.post(`/areas/update`, params)
    },
    remove(id) {
        return Vue.axios.get(`/areas/remove/${id}`)
    },
    get(id) {
        return Vue.axios.get(`/areas/${id}`)
    },
    combinedList() {
        return Vue.axios.get(`/area/get`)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
